import React, { Component } from 'react';
import config from "./../config.json";
import authFetch from "../authFetch";
import RolCard from '../components/rolCard';
import IslemlerCard from '../components/islemlerCard';
import ToastCard from '../components/toast';
import RightMenu from '../components/rightMenu'
import _ from "lodash";


class RolSayfa extends Component {
  state = {
    roller: [],
    personeller :  [],
    showDetail: false,
    rolDetail: {},
    response: {},
    showToast: false,
    datetime: Date.now(),
  }

  headers = {
    Authorization : 'Bearer ' +  (localStorage.getItem('user')  == null ? '' : JSON.parse(localStorage.getItem('user'))["token"]),
    'Content-Type': 'application/json',
  }

  normalizeRol = (rol) => {
    if (!rol) {
      return { RolId: null, Adi: '', Islemler: [] };
    }

    return {
      RolId: rol.RolId ?? rol.rolId ?? null,
      Adi: rol.Adi ?? rol.adi ?? '',
      Islemler: rol.Islemler ?? rol.islemler ?? [],
    };
  }

  normalizeRolResponse = (response) => {
    if (!response) {
      return [];
    }
    return response.map(this.normalizeRol);
  }

  normalizePersonel = (personel) => {
    if (!personel) {
      return {};
    }

    if (personel.kullanici) {
      return {
        KullaniciId: personel.kullanici.kullaniciId ?? null,
        Ad: personel.kullanici.ad ?? '',
        Soyad: personel.kullanici.soyad ?? '',
        Resim: personel.kullanici.resim ?? null,
        AktifMi: personel.kullanici.aktifMi ?? false,
        Roller: (personel.kullaniciRolleri || []).map((rol) => rol.rolId) || [],
      };
    }

    return {
      KullaniciId: personel.KullaniciId ?? personel.kullaniciId ?? null,
      Ad: personel.Ad ?? personel.ad ?? '',
      Soyad: personel.Soyad ?? personel.soyad ?? '',
      Resim: personel.Resim ?? personel.resim ?? null,
      AktifMi: personel.AktifMi ?? personel.aktifMi ?? false,
      Roller: personel.Roller || [],
    };
  }

  normalizePersonelResponse = (response) => {
    if (!response) {
      return [];
    }
    const list = response.kullanicilar || response.Kullanicilar || [];
    return list.map(this.normalizePersonel);
  }

  componentDidMount() {
    this.setValues();
    document.title = "Altınkaynak Personel Sistemi - Roller"
  }

  componentWillUnmount() {
  }

  async setValues() {
    var roller = [];
    await authFetch(config.apiEndpoint + 'roles', {method: 'GET', headers:this.headers}).then(function(response) {
      return response.json();
    })
    .then(function(jsonStr) {
      roller = jsonStr;
    });

    var islemler = [];
    await authFetch(config.apiEndpoint + 'operations', {method: 'GET', headers:this.headers}).then(function(response) {
      return response.json();
    })
    .then(function(jsonStr) {
      islemler = jsonStr;
    });

    var gruppedIslemler =  _(islemler).groupBy('IslemGrubu').map((islemler, islemGrubu) => {
      const grupIslemler = islemler.map(islem => islem);
      return ({
        islemGrubu,
        grupIslemler,
      })
    })
    .value()

    var personeller = [];
    await authFetch(config.apiEndpoint + 'personel/Search', {method: 'POST', body:JSON.stringify({}), headers:this.headers}).then(function(response) {
      return response.json();
    })
    .then(function(jsonStr) {
      personeller = jsonStr;
    });

    const normalizedPersoneller = this.normalizePersonelResponse(personeller);

    const normalizedRoller = this.normalizeRolResponse(roller);

    this.setState({ roller: normalizedRoller, islemler : gruppedIslemler, personeller: normalizedPersoneller })
  }


  cleanupModalAfterClose = () => {
    const modalElement = document.getElementById('modalCenter');
    if (!modalElement) {
      return;
    }
    if (window.bootstrap && window.bootstrap.Modal) {
      const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    } else {
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.removeAttribute('aria-modal');
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      const modalBackdrops = document.getElementsByClassName('modal-backdrop');
      while (modalBackdrops.length > 0) {
        modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
      }
    }
  }

  handleOpenModal = (rolDetail) => {
    this.setState({ showDetail: true, rolDetail: rolDetail });
  }

  handleCloseModal = (event) => {
    this.setState({ showDetail: false }, () => {
      this.cleanupModalAfterClose();
    });
  }

  handleAddRol = (event) => {
    this.setState({ showDetail: true, rolDetail: {Adi:'', Islemler:[]} });
  }

  handleIslemChange =  (target) => {
    var newRolDetail = this.state.rolDetail;
    const islemler = newRolDetail.Islemler || newRolDetail.islemler || [];
    if(target.checked){
      islemler.push(parseInt(target.value));
    }
    else{
      const idx = islemler.indexOf(parseInt(target.value));
      if (idx >= 0) {
        islemler.splice(idx,1);
      }
    }
    newRolDetail.Islemler = islemler;
    this.setState({ rolDetail: newRolDetail });
    
  }

  handleSaveForm = async (event) => {
    event.preventDefault();

    const rolDetailChanged = Object.assign({}, this.state.rolDetail);

    rolDetailChanged.Adi = event.target['adi'].value;
    rolDetailChanged.Islemler = rolDetailChanged.Islemler || rolDetailChanged.islemler || rolDetailChanged['islemler'] || [];

    var mesaj = ''
    let responseOk = false;
    let response;
    if (rolDetailChanged.RolId == null) {
      response = await authFetch(config.apiEndpoint + 'roles', {method: 'POST', body:JSON.stringify({ RolId: rolDetailChanged.RolId, Adi: rolDetailChanged.Adi, Islemler: rolDetailChanged.Islemler }), headers:this.headers});
    }
    else {
      this.setState({ rolDetail: rolDetailChanged });
      response = await authFetch(config.apiEndpoint + 'roles/' + this.state.rolDetail.RolId, {method: 'PUT', body:JSON.stringify({ RolId: rolDetailChanged.RolId, Adi: rolDetailChanged.Adi, Islemler: rolDetailChanged.Islemler }), headers:this.headers});
    }
    responseOk = response.ok;
    mesaj = await response.json();

    if (responseOk) {
      this.setState({ showDetail: false, response: mesaj, showToast: true, datetime: Date.now(), }, () => {
        this.cleanupModalAfterClose();
      });
    } else {
      this.setState({ response: mesaj, showToast: true, datetime: Date.now(), });
    }
    this.setValues();
  }

  handleDeleteRol = async (rolDetail) => {
    var mesaj = '';
    await authFetch(config.apiEndpoint + 'roles/' + (rolDetail.RolId ?? rolDetail.rolId), {method: 'DELETE', headers:this.headers}).then(function(response) {
      return response.json();
    })
    .then(function(jsonStr) {
      mesaj = jsonStr;
    });
    this.setState({ response: mesaj, showToast: true, datetime: Date.now(), });
    this.setValues();
  }

  render() {
    return <React.Fragment>
      <RightMenu />

      <ToastCard response={this.state.response} showToast={this.state.showToast} datetime={this.state.datetime} />
      <div className="modal fade" id="modalCenter" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            {this.state.showDetail ?
              <form id="formAuthenticationc" className="mb-3" onSubmit={this.handleSaveForm}>
                <div className="modal-header">
                  <h5 className="modal-title" id="modalCenterTitle">{this.state.rolDetail['Adi']}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row g-2">
                    <div className="col mb-0 form-floating">
                      <input
                        type="text"
                        id="adi"
                        name="adi"
                        className="form-control"
                        placeholder="Adı"
                        key={this.state.rolDetail['Adi']}
                        defaultValue={this.state.rolDetail['Adi']}
                      />
                      <label htmlFor="adi" className="form-label">Adı</label>
                    </div>
                  </div>

                  {this.state.islemler.map(tag => <IslemlerCard key={this.state.rolDetail['Adi'] + tag['islemGrubu'] + (this.state.roller.filter((rol) => rol.RolId === this.state.rolDetail['RolId']).length > 0 ? this.state.roller.filter((rol) => rol.RolId === this.state.rolDetail['RolId'])[0].Islemler.toString() : 'New')} values={tag} handleIslemChangeCallback={this.handleIslemChange} rolIslemleri={this.state.roller.filter((rol) => rol.RolId === this.state.rolDetail['RolId']).length > 0 ? this.state.roller.filter((rol) => rol.RolId === this.state.rolDetail['RolId'])[0].Islemler : null} />)}

                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">Kaydet</button>
                </div>
              </form> : null}
          </div>
        </div>
      </div>

      <div className="content-wrapper">

        <div className="container-xxl flex-grow-1 container-p-y">
          <h4 className="fw-bold py-2 mb-1">Roller
            <button type="button" className="btn btn-outline-primary thin ml20" data-bs-toggle="modal"
              data-bs-target="#modalCenter" onClick={this.handleAddRol}>
              <i className="tf-icons bx bx-building"></i>
              Rol Ekle
            </button>
          </h4>
          
          <div className="row row-cols-1 row-cols-md-3 g-4 mb-5">
            <table className="table">
              <thead>
                <tr>
                  <th>Adı</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {this.state.roller.map(tag => <RolCard key={tag['Adi']} parentCallback={this.handleOpenModal} parentDeleteCallback={this.handleDeleteRol} values={tag} users={this.state.personeller} />)}
              </tbody>
            </table>
          </div>

        </div>

        <footer className="content-footer footer bg-footer-theme">
          <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
            <div className="mb-2 mb-md-0">
              © Altınkaynak
            </div>
          </div>
        </footer>

        <div className="content-backdrop fade"></div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>

    </React.Fragment>;
  }
}

export default RolSayfa;
